import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import PillNav from "./PillNav";
import PillTabContent from "./PillTabContent";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { PillsTabTitle } from "../../../../Constants/Constants";
import { PillsTabSubTitle } from "../../../../Data/UiKits/Tabs";

const PillsTab = () => {
  const [basicTab, setBasicTab] = useState("3");

  return (
    <Col sm="12" xxl="6">
      <Card className="height-equal">
        <CommonCardHeader title={PillsTabTitle} span={PillsTabSubTitle} />
        <CardBody>
          <PillNav basicTab={basicTab} setBasicTab={setBasicTab} />
          <PillTabContent tabId={basicTab} />
        </CardBody>
      </Card>
    </Col>
  );
};
export default PillsTab